import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { catchError, Observable, retry, throwError } from 'rxjs';
import { environment } from 'src/environments/environment';
import { TramiteEmvs } from '../listado/listado-tramites-emvs/tramite-emvs';
import { AutorizacionEmvs } from '../model/autorizacionEmvs';
import { CircunstanciasEmvs } from '../model/circunstanciasEmvs';
import { ConsultaEmvs } from '../model/consultaEmvs';
import { DatosPersonalesEmvs } from '../model/datospersonalesEmvs';
import { DatosRepresentanteEmvs } from '../model/datosrepresentanteEmvs';
import { DenominacionPuesto } from '../model/denominacionpuesto';
import { DistritosEmvs } from '../model/distritosEmvs';
import { InstanciaGeneral } from '../model/instanciageneral';
import { OrdenConvocatoria } from '../model/ordenconvocatoria';
import { PuestoEmvs } from '../model/puestoEmvs';
import { UnidadFamiliarEmvs } from '../model/unidadfamiliarEmvs';
import { VulnerabilidadEmvs } from '../model/vulnerabilidadEmvs';

@Injectable({
  providedIn: 'root'
})

export class SolicituCustomService {


  API_URL: string = environment.API_URL;

  constructor(
    private http: HttpClient
  ) { }

  saveTramite(form: any): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_custom/save`;
    return this.http.post(API_URL, form)
  }

  saveTramiteWithoutData(form: FormGroup): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_custom/save`;
    return this.http.post(API_URL, form)
  }


  savePdf(pdf, idTramite): Observable<any> {
    let API_URL = `${this.API_URL}/tramite_custom/savePdf`;
    return this.http.post(API_URL, { pdf, idTramite });
  }

  saveDocumentosAdjuntos(data: any): Observable<any> {

    let API_URL = `${this.API_URL}/documentos_adjuntos_custom/save`;
    return this.http.post(API_URL, data);
  }


  updateEstadoTramite(tramite: any) {
    tramite.usuario_id = null
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_custom/updateEstado`, tramite);
  }
  updateEstadoTramiteById(idTramite: any) {
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_custom/updateEstadoFinalIdTramite/${idTramite}`,'');
  }
  updateLastVisitedTab(tramite: Partial<TramiteEmvs>) {
    tramite.procedimiento_id = null
    tramite.usuario_id = null
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_custom/updateLastVisitedTab`, tramite);
  }

  updateTramite(tramite: Partial<TramiteEmvs>) {
    tramite.procedimiento_id = null
    tramite.usuario_id = null
    return this.http.post<TramiteEmvs>(`${this.API_URL}/tramite_custom/updateLastVisitedTab`, tramite);
  }
  
  getByIdNexcloud(idNexcloud: string) {
    let API_URL = `${this.API_URL}/documentoeni/getByIdNexcloud/${idNexcloud}`;
    return this.http.get(API_URL);
  }

  getDocAdjuntosByIdTramite(idTramite: string) {
    let API_URL = `${this.API_URL}/documentos_adjuntos_custom/getByIdTramite/${idTramite}`;
    return this.http.get(API_URL);
  }

  handleError(error: any) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      errorMessage = error.error.message;
    } else {
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    return throwError(() => {
      return errorMessage;
    });
  }
}
